var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMaterialSymbolsSearchRounded = function SvgMaterialSymbolsSearchRounded(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.917 13.333q-2.27 0-3.844-1.573Q2.501 10.187 2.5 7.917t1.573-3.844T7.917 2.5t3.844 1.573 1.572 3.844a5.08 5.08 0 0 1-1.083 3.166l4.667 4.667a.8.8 0 0 1 .229.583.8.8 0 0 1-.23.584.8.8 0 0 1-.583.229.8.8 0 0 1-.583-.23l-4.667-4.666a5.08 5.08 0 0 1-3.167 1.083m0-1.666q1.562 0 2.656-1.094 1.095-1.093 1.094-2.656T10.573 5.26Q9.48 4.168 7.917 4.167T5.26 5.26 4.167 7.917q-.003 1.56 1.094 2.656t2.656 1.094"
  })));
};
export default SvgMaterialSymbolsSearchRounded;